// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"FormColumn_wrapper__2RQyO"};